module.exports = __webpack_public_path__ + "img/hr-V-L-5-unload-standup-shadow.7a917d31.png";